<template>
  <Swiper
    :slidesPerView="1"
    :spaceBetween="24"
    :centeredSlides="false"
    :preventClicks="true"
    :loop="true"
    :autoplay="{
      delay: 8000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    }"
    :breakpoints="{
      0: { slidesPerView: 3, spaceBetween: 12 },
      420: { slidesPerView: 4, spaceBetween: 16 },
      576: { slidesPerView: 4 },
      768: { slidesPerView: 4 },
      992: { slidesPerView: 5 },
      1200: { slidesPerView: 6 },
      1440: { slidesPerView: 6 },
    }"
    :modules="modules"
    class="partner-slide d-md-none"
  >
    <SwiperSlide v-for="(slide, i) in effectiveSlides" :key="i">
      <RouterLink to="/">
        <img :src="slide.image" alt="partner" />
      </RouterLink>
    </SwiperSlide>
  </Swiper>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper/modules";

const defaultImages = [
  require("@/assets/images/partner-7.png"),
  require("@/assets/images/partner-8.png"),
  require("@/assets/images/partner-9.png"),
  require("@/assets/images/partner-10.png"),
  require("@/assets/images/partner-11.png"),
];

export default defineComponent({
  name: "PartnerSlide",
  components: { Swiper, SwiperSlide },
  props: {
    customImages: { type: Array as () => Array<{ image_url: string }>, default: () => [] },
  },
  setup(props) {
    const effectiveSlides = computed(() => {
      const cms = props.customImages.filter((i) => i.image_url).map((i) => ({ image: i.image_url }));
      return cms.length > 0 ? cms : defaultImages.map((img) => ({ image: img }));
    });
    return { effectiveSlides, modules: [Autoplay] };
  },
});
</script>
